import {
  Button,
  Heading,
  Link,
  Paragraph,
  PopcornProvider,
  RefreshCwIcon,
} from '@buffer-mono/popcorn'

import styles from './MountFailureScreen.module.css'

import type { JSX } from 'react'

const handleRefresh = (): void => {
  location.reload()
}

export const MOUNT_FAILURE_SUPPORT_URL =
  'https://support.buffer.com/?openContact=true'

export type MountFailureScreenProps = {
  message: string
}

export function MountFailureScreen({
  message,
}: MountFailureScreenProps): JSX.Element {
  return (
    <PopcornProvider _toaster={false}>
      <div className={styles.root} role="alert">
        <Heading as="h2" size="large">
          Buffer couldn&apos;t load
        </Heading>
        <Paragraph size="lg" align="center" className={styles.message}>
          {message}{' '}
          <Link href={MOUNT_FAILURE_SUPPORT_URL} external>
            Contact support
          </Link>
        </Paragraph>
        <Button variant="secondary" onClick={handleRefresh}>
          <RefreshCwIcon />
          Refresh
        </Button>
      </div>
    </PopcornProvider>
  )
}
